import React, { useEffect, useState } from "react";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  CloseIcon,
  DownDropArrow,
  FilterIcon,
  filterBlackIcon,
} from "../../../assets/images";
import Select from "react-select";
import { EMPLOYMENT_STATUS } from "../../../constant/userProfileConstant";

type DropDownType = { value: null | string; label: string };

type AppProps = {
  setAllActiveStatus: React.Dispatch<React.SetStateAction<number[]>>;
  allActiveStatus: any;
  type: string;
  departmentFilterValue?: DropDownType;
  employmentStatusFilterValue?: DropDownType;
  setUsersDepartmentText?: React.Dispatch<React.SetStateAction<string>>;
  setDepartmentFilterValue?: React.Dispatch<React.SetStateAction<DropDownType>>;
  setEmploymentStatusFilterValue?: React.Dispatch<
    React.SetStateAction<DropDownType>
  >;
  setUsersDepartmentOffset?: React.Dispatch<React.SetStateAction<number>>;
  finalUsersDepartmentList?: any;
  usersDepartmentFetching?: boolean;
  checkUsersDepartmentBottom?: () => void;
  handleApplyFilter?: () => void;
  clearFilter?: () => void;
  applyFilter?: boolean;
  isAllUsersStatus?: boolean;
  filterCount?: any;
};

export const FILTER_STATUS_FORMAT = [
  // {
  //     "label": "All Status",
  //     "value": "10",
  //     "defaultChecked": true,
  //     "checked": true,
  //     "_id":"status1"
  // },
  {
    label: "Active",
    value: "1",
    defaultChecked: true,
    checked: true,
    _id: "status2",
  },
  {
    label: "Inactive",
    value: "0",
    defaultChecked: true,
    checked: true,
    _id: "status3",
  },
];
const Filter = ({
  setAllActiveStatus,
  allActiveStatus,
  type,
  setUsersDepartmentText,
  setUsersDepartmentOffset,
  finalUsersDepartmentList,
  checkUsersDepartmentBottom,
  usersDepartmentFetching,
  departmentFilterValue,
  employmentStatusFilterValue,
  setDepartmentFilterValue,
  setEmploymentStatusFilterValue,
  handleApplyFilter,
  clearFilter,
  applyFilter,
  filterCount,
  isAllUsersStatus,
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  const count: number =
    type === "internal"
      ? Object.values(filterCount).filter((e: any) =>
          e?.hasOwnProperty("value") ? e.value !== "" : e !== ""
        ).length
      : 0;

  const handleDepartvalueChange = (data: DropDownType) => {
    setDepartmentFilterValue?.(data);
  };
  const handleEmploymentStatusChange = (data: DropDownType) => {
    setEmploymentStatusFilterValue?.(data);
  };

  const resetFilter = () => {
    setDepartmentFilterValue?.({ value: null, label: "Select..." });
    setEmploymentStatusFilterValue?.({ value: null, label: "Select..." });
    // setAllActiveStatus([]);
  };

  const empty = () => {
    setDepartmentFilterValue?.({
      value: filterCount?.department?.value
        ? filterCount?.department?.value
        : null,
      label: filterCount?.department?.value
        ? filterCount?.department?.label
        : "Select...",
    });
    setEmploymentStatusFilterValue?.({
      value: filterCount?.employment_status?.value
        ? filterCount?.employment_status?.value
        : null,
      label: filterCount?.employment_status?.value
        ? filterCount?.employment_status?.label
        : "Select...",
    });
    if (filterCount?.active && filterCount?.inactive) {
      setAllActiveStatus([+filterCount?.active, +filterCount?.inactive]);
    } else if (filterCount?.active) {
      setAllActiveStatus([+filterCount?.active]);
    } else if (filterCount?.inactive) {
      setAllActiveStatus([+filterCount?.inactive]);
    } else {
      setAllActiveStatus([]);
    }
  };

  return (
    <div className="form-group mr-1">
      <ButtonDropdown
        color="#bfcbe1"
        isOpen={toggle}
        toggle={() => {
          type === "internal" && filterCount === 0 && toggle
            ? resetFilter()
            : type === "internal" && empty();
          setToggle(!toggle);
        }}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            toggle
              ? {
                  color: "#dd4433",
                  border: "1px solid #dd4433",
                  backgroundColor: "#fff6f5",
                }
              : { border: "1px solid#bfcbe1" }
          }
          outline
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span
              className={
                type !== "internal"
                  ? allActiveStatus?.includes(10) ||
                    allActiveStatus?.length === 0
                    ? ""
                    : "payment-count"
                  : count != 0
                  ? "payment-count"
                  : ""
              }
            >
              <span>
                {type !== "internal"
                  ? allActiveStatus?.includes(10) ||
                    allActiveStatus?.length === 0
                    ? ""
                    : allActiveStatus?.length
                  : count != 0
                  ? count
                  : ""}
              </span>
            </span>
            {type !== "internal" && (
              <p style={{ margin: 0, color: "#262a44" }}>
                {allActiveStatus?.length === 0 ? `All Status` : "Selected"}
              </p>
            )}
            <img
              src={
                type === "internal"
                  ? allActiveStatus?.length !== 0
                    ? FilterIcon
                    : filterBlackIcon
                  : DownDropArrow
              }
              alt="down_arrow"
            />
          </div>
        </DropdownToggle>

        <DropdownMenu right>
          <div
            className="p-3"
            style={{
              width: "350px",
              padding: "15px 25px 30px",
              display: "inline-block",
            }}
          >
            <div className="d-flex justify-content-between mt-0 mb-0">
              <h5 className="text-center ">Filter</h5>
              <div
                className="pointer"
                onClick={() => {
                  // toggle={() => {
                  type === "internal" && filterCount === 0 && toggle
                    ? resetFilter()
                    : type === "internal" && empty();
                  setToggle(!toggle);
                  // }}
                }}
              >
                <img src={CloseIcon} alt="" />
              </div>
            </div>
            <hr className="mt-0 mb-2" />
            {!isAllUsersStatus &&
              FILTER_STATUS_FORMAT?.map((el: any, i: number) => {
                return (
                  <div
                    style={{ textAlign: "left", display: "flex" }}
                    className="p-2"
                  >
                    <input
                      type="checkbox"
                      style={{
                        width: "19px",
                        height: "19px",
                      }}
                      className="checkbox"
                      checked={
                        allActiveStatus.includes(+el?.value) ||
                        (allActiveStatus?.length === 0 && +el?.value === 10)
                      }
                      onChange={(data: any) => {
                        if (data?.target.checked && +el?.value == 10) {
                          let inputValue = [+el?.value, 0, 1];
                          setAllActiveStatus([...inputValue]);
                        } else if (data?.target?.checked && +el?.value !== 10) {
                          if (allActiveStatus?.includes(10)) {
                            let findAllStatus = allActiveStatus.indexOf(10);
                            let filterAllStatus = allActiveStatus?.splice(
                              findAllStatus,
                              1
                            );
                            setAllActiveStatus(filterAllStatus);
                          }
                          setAllActiveStatus([...allActiveStatus, +el?.value]);
                        } else if (+el?.value != 10) {
                          if (allActiveStatus?.includes(10)) {
                            let findAllStatus = allActiveStatus?.indexOf(10);
                            allActiveStatus?.splice(findAllStatus, 1);
                            let finalData = allActiveStatus?.filter(
                              (value: number) =>
                                value != el?.value && value != 10
                            );
                            setAllActiveStatus([...finalData]);
                          } else {
                            setAllActiveStatus([
                              ...allActiveStatus.filter(
                                (value: number) => value != el?.value
                              ),
                            ]);
                          }
                        } else {
                          setAllActiveStatus([
                            ...allActiveStatus?.filter(
                              (value: number) => value != el?.value
                            ),
                          ]);
                        }
                      }}
                    />

                    <span className="ml-2" style={{ fontSize: "14px" }}>
                      {el?.label}
                    </span>
                  </div>
                );
              })}
            {type === "internal" && (
              <div className="p-2">
                <label htmlFor="department">Department</label>
                <Select
                  options={finalUsersDepartmentList}
                  value={departmentFilterValue}
                  onChange={(data: any) => handleDepartvalueChange(data)}
                  isSearchable={true}
                  isLoading={usersDepartmentFetching}
                  onMenuClose={() => setUsersDepartmentOffset?.(0)}
                  onMenuScrollToBottom={checkUsersDepartmentBottom}
                  onInputChange={(e) => {
                    setUsersDepartmentText?.(e);
                    setUsersDepartmentOffset?.(0);
                  }}
                />
              </div>
            )}
            {type === "internal" && (
              <div className="p-2">
                <label htmlFor="gender">Employment Status </label>

                <Select<any, false>
                  inputProps={{ autoComplete: "nope" }}
                  placeholder={"Select"}
                  options={EMPLOYMENT_STATUS?.filter(
                    (el: any) => el?.label !== "Select…"
                  )}
                  value={employmentStatusFilterValue}
                  onChange={handleEmploymentStatusChange}
                />
              </div>
            )}
            {type === "internal" && (
              <div className="d-flex align-items-center justify-content-end mt-3">
                <button
                  className="mr-2 btn btn-outline"
                  onClick={() => {
                    clearFilter?.();
                    setToggle(!toggle);
                  }}
                >
                  Clear Filter
                </button>
                <button
                  className="pl-4 pr-4 btn btn-primary"
                  onClick={() => {
                    handleApplyFilter?.();
                    setToggle(!toggle);
                  }}
                >
                  Apply
                </button>
              </div>
            )}
          </div>
        </DropdownMenu>
      </ButtonDropdown>
    </div>
  );
};

export default Filter;
